export default __webpack_public_path__ + "static/media/A_arte_de_brincar_4.d5f2615d.jpg";